<script setup>
const props = defineProps({
  text: String,
});
</script>

<template>
  <div class="mb-xl last:mb-0" v-html="text"></div>
</template>

<style></style>
